import { defineComponent as V, openBlock as f, createElementBlock as k, createElementVNode as g, toDisplayString as $, Fragment as S, renderList as x, normalizeClass as O, ref as I, onMounted as H, createVNode as C, createBlock as R, computed as D, renderSlot as q, watchEffect as G, resolveDynamicComponent as J, unref as L, createSlots as K, withCtx as Q } from "vue";
import { Info as F, DateTime as w, Interval as X } from "luxon";
var h = /* @__PURE__ */ ((e) => (e.single = "single", e.range = "range", e))(h || {}), T = /* @__PURE__ */ ((e) => (e.scroll = "scroll", e.flat = "flat", e))(T || {}), B = /* @__PURE__ */ ((e) => (e.start = "start", e.end = "end", e))(B || {});
const b = {
  type: String,
  default: h.single
}, N = {
  type: [String, Object, Array],
  default: null
}, W = {
  type: Array,
  required: !0
}, P = {
  type: Array,
  required: !0
}, E = {
  type: Number,
  default: 0
}, j = {
  type: Number,
  default: 2
};
function Y(e = "en") {
  const m = F.getStartOfWeek({ locale: e }) - 1, c = F.weekdays("short", { locale: e }).map((u, y) => ({
    name: u,
    isWeekend: y >= 5
  })), o = c.splice(0, m);
  return c.push(...o), c;
}
function Z(e = 1, m = "en") {
  const a = [], c = w.local({ locale: m }).startOf("month");
  for (let o = 0; o < e; o++) {
    const u = ee(c.plus({ month: o }));
    a.push(u);
  }
  return a;
}
function ee(e) {
  const a = X.fromDateTimes(e, e.plus({ month: 1 })).splitBy({ days: 1 }).reduce((c, { start: o }, u) => {
    if (!o)
      return c;
    const y = u === 0;
    if (!(o.localWeekday === 1))
      if (y)
        o = o.startOf("week", { useLocaleWeeks: !0 });
      else
        return c;
    const v = te(o, e.month);
    return [...c, v];
  }, []);
  return {
    index: e.month,
    name: e.monthLong,
    year: e.year,
    weeks: a
  };
}
function te(e, m) {
  const a = F.weekdays().length, c = [];
  for (let o = 0; o < a; o++) {
    const u = ne(e.plus({ day: o }), m);
    c.push(u);
  }
  return { days: c };
}
function ne(e, m) {
  return {
    date: e,
    isForeign: e.month !== m,
    isFirst: e.day === 1,
    isLast: e.day === e.daysInMonth
  };
}
const se = { class: "monster-calendar__month" }, ae = { class: "monster-calendar__text monster-calendar__text--month-name" }, oe = { class: "monster-calendar__font monster-calendar__font--month-name" }, re = { class: "monster-calendar__weeks" }, le = ["disabled", "onClick", "onMouseenter"], ie = { class: "monster-calendar__font monster-calendar__font--day" }, U = /* @__PURE__ */ V({
  __name: "MonthView",
  props: {
    name: {
      type: String,
      required: !0
    },
    year: {
      type: Number,
      required: !0
    },
    weeks: {
      type: Array,
      required: !0
    },
    pickType: b,
    modelValue: N,
    hoveredDay: {
      type: Object,
      default: null
    }
  },
  emits: ["day-click", "update:hovered-day"],
  setup(e, { emit: m }) {
    const a = e, c = m, o = w.local().startOf("day");
    function u(t) {
      return t.date.toMillis() < o.toMillis();
    }
    function y(t) {
      return t.date.toMillis() === o.toMillis();
    }
    function M(t) {
      return t.date.isWeekend;
    }
    function v(t) {
      const { isForeign: s, date: r } = t, { pickType: _, modelValue: n } = a;
      if (s)
        return !1;
      switch (_) {
        case h.single:
          return !n || !("toMillis" in n) ? !1 : r.toMillis() === n.toMillis();
        case h.range:
          if (!Array.isArray(n))
            return !1;
          if (n[0] && n[1])
            return r.toMillis() >= n[0].toMillis() && r.toMillis() <= n[1].toMillis();
          if (n[0])
            return r.toMillis() === n[0].toMillis();
      }
    }
    function d(t) {
      const { isForeign: s, date: r } = t, { pickType: _, modelValue: n, hoveredDay: i } = a;
      return s || _ !== h.range || !i || n[0] && n[1] || !n[0] && !n[1] || i.toMillis() === n[0].toMillis() ? !1 : i.toMillis() < n[0].toMillis() ? r.toMillis() > i.toMillis() && r.toMillis() < n[0].toMillis() : r.toMillis() < i.toMillis() && r.toMillis() > n[0].toMillis();
    }
    function p(t) {
      const { isForeign: s, date: r } = t, { pickType: _, modelValue: n } = a;
      return s || _ !== h.range || !n[0] ? !1 : r.toMillis() === n[0].toMillis();
    }
    function l(t) {
      const { isForeign: s, date: r } = t, { pickType: _, modelValue: n } = a;
      return s || _ !== h.range || !n[1] ? !1 : r.toMillis() === n[1].toMillis();
    }
    return (t, s) => (f(), k("div", se, [
      g("div", ae, [
        g("span", oe, $(e.name) + " " + $(e.year), 1)
      ]),
      g("div", re, [
        (f(!0), k(S, null, x(a.weeks, (r, _) => (f(), k("div", {
          class: "monster-calendar__week",
          key: _
        }, [
          (f(!0), k(S, null, x(r.days, (n, i) => (f(), k("button", {
            type: "button",
            key: i,
            class: O(["monster-calendar__day", {
              "monster-calendar__day--foreign": n.isForeign,
              "monster-calendar__day--today": y(n),
              "monster-calendar__day--weekend": M(n),
              "monster-calendar__day--first": n.isFirst,
              "monster-calendar__day--last": n.isLast,
              "monster-calendar__day--selected": v(n),
              "monster-calendar__day--range-start": p(n),
              "monster-calendar__day--range-end": l(n),
              "monster-calendar__day--range-hover": d(n)
            }]),
            disabled: n.isForeign || u(n),
            onClick: (A) => c("day-click", n),
            onMouseenter: (A) => c("update:hovered-day", n.date),
            onMouseleave: s[0] || (s[0] = (A) => c("update:hovered-day", null))
          }, [
            g("span", ie, $(n.date.day), 1)
          ], 42, le))), 128))
        ]))), 128))
      ])
    ]));
  }
}), ce = { class: "monster-calendar__week-day-names" }, de = { class: "monster-calendar__font monster-calendar__font--week-day-name" }, z = /* @__PURE__ */ V({
  __name: "WeekDayNamesView",
  props: {
    weekDayNames: W
  },
  setup(e) {
    const m = e;
    return (a, c) => (f(), k("div", ce, [
      (f(!0), k(S, null, x(m.weekDayNames, (o) => (f(), k("div", {
        key: o.name,
        class: O(["monster-calendar__text monster-calendar__text--week-day-name", { "monster-calendar__text--week-day-weekend": o.isWeekend }])
      }, [
        g("span", de, $(o.name), 1)
      ], 2))), 128))
    ]));
  }
}), me = { class: "monster-calendar__display--type--scroll" }, ue = { class: "monster-calendar__header" }, ye = { class: "monster-calendar__months" }, pe = /* @__PURE__ */ V({
  __name: "ScrollDisplay",
  props: {
    pickType: b,
    modelValue: N,
    weekDayNames: W,
    months: P,
    modelMonthIndex: E
  },
  emits: ["day-click"],
  setup(e, { emit: m }) {
    const a = e, c = m, o = I(null), u = I(null), y = I(null);
    function M(v, d = "instant") {
      var t;
      const p = y.value.offsetTop, l = (t = u.value[v]) == null ? void 0 : t.$el.offsetTop;
      y.value.scrollTo({
        top: l - p,
        behavior: d
      });
    }
    return H(() => M(a.modelMonthIndex)), (v, d) => (f(), k("div", me, [
      g("div", ue, [
        C(z, {
          class: "monster-calendar__week-day-names",
          "week-day-names": e.weekDayNames
        }, null, 8, ["week-day-names"])
      ]),
      g("div", {
        class: "monster-calendar__wrapper",
        ref_key: "wrapperRef",
        ref: y
      }, [
        g("div", ye, [
          (f(!0), k(S, null, x(e.months, (p, l) => (f(), R(U, {
            ref_for: !0,
            ref_key: "monthsRef",
            ref: u,
            key: l,
            name: p.name,
            year: p.year,
            weeks: p.weeks,
            pickType: e.pickType,
            "model-value": e.modelValue,
            class: "monster-calendar__month",
            onDayClick: d[0] || (d[0] = (t) => c("day-click", t)),
            "hovered-day": o.value,
            "onUpdate:hoveredDay": d[1] || (d[1] = (t) => o.value = t)
          }, null, 8, ["name", "year", "weeks", "pickType", "model-value", "hovered-day"]))), 128))
        ])
      ], 512)
    ]));
  }
}), fe = { class: "monster-calendar__display--type--flat" }, he = { class: "monster-calendar__wrapper" }, ke = { class: "monster-calendar__header" }, _e = /* @__PURE__ */ V({
  __name: "FlatDisplay",
  props: {
    pickType: b,
    modelValue: N,
    weekDayNames: W,
    months: P,
    monthsToShow: j,
    modelMonthIndex: E
  },
  emits: ["day-click"],
  setup(e, { emit: m }) {
    const a = e, c = m, o = I(null), u = I(a.modelMonthIndex), y = D(() => {
      const d = u.value;
      return {
        prev: d > 0,
        next: d < a.months.length - a.monthsToShow
      };
    });
    function M(d = 0) {
      !d || d === -1 && !y.value.prev || d === 1 && !y.value.next || (u.value += d);
    }
    const v = D(() => {
      const d = u.value, [p, l] = [d, d + a.monthsToShow];
      return a.months.slice(p, l);
    });
    return (d, p) => (f(), k("div", fe, [
      g("div", he, [
        (f(!0), k(S, null, x(v.value, (l, t) => (f(), k("div", {
          class: "monster-calendar__item",
          key: t
        }, [
          g("div", ke, [
            C(z, {
              class: "monster-calendar__week-day-names",
              "week-day-names": e.weekDayNames
            }, null, 8, ["week-day-names"])
          ]),
          C(U, {
            name: l.name,
            year: l.year,
            weeks: l.weeks,
            pickType: e.pickType,
            "model-value": e.modelValue,
            class: "monster-calendar__month",
            onDayClick: p[0] || (p[0] = (s) => c("day-click", s)),
            "hovered-day": o.value,
            "onUpdate:hoveredDay": p[1] || (p[1] = (s) => o.value = s)
          }, null, 8, ["name", "year", "weeks", "pickType", "model-value", "hovered-day"])
        ]))), 128))
      ]),
      q(d.$slots, "navigation", {
        navigationState: y.value,
        changeMonthIndex: M
      })
    ]));
  }
}), we = /* @__PURE__ */ V({
  __name: "CalendarBase",
  props: {
    pickType: b,
    modelValue: N,
    displayMode: {
      type: String,
      default: T.scroll
    },
    monthsToShow: j,
    locale: {
      type: String,
      default: "en"
    },
    monthsCount: {
      type: Number,
      default: 12
    },
    rangeLock: {
      type: String,
      default: void 0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: m }) {
    const a = e, c = m;
    G(() => {
      const { pickType: l, modelValue: t } = a;
      let s = !1;
      switch (l) {
        case h.single:
          s = !t || typeof t == "string";
          break;
        case h.range:
          s = Array.isArray(t);
          break;
      }
      if (!s)
        throw new Error('Props: "pickType" & "modelValue" mismatch.');
    });
    const o = D(() => {
      const { modelValue: l } = a;
      return Array.isArray(l) ? l.map((t) => t && w.fromISO(t)) : l && w.fromISO(l);
    }), u = D(() => Y(a.locale)), y = D(() => Z(a.monthsCount, a.locale));
    function M(l) {
      const { date: t } = l, s = t.toString();
      let r = null;
      const { pickType: _, rangeLock: n, modelValue: i } = a;
      switch (_) {
        case h.single:
          r = s;
          break;
        case h.range:
          if (!a.rangeLock) {
            i[0] && i[1] ? r = [s, null] : i[0] ? t.toMillis() < w.fromISO(i[0]).toMillis() ? r = [s, null] : r = [i[0], s] : r = [s, null];
            break;
          }
          if (i[0] && !i[1]) {
            t.toMillis() <= w.fromISO(i[0]).toMillis() ? r = [s, i[0]] : r = [i[0], s];
            break;
          }
          n === B.start ? t.toMillis() <= w.fromISO(i[1]).toMillis() ? r = [s, i[1]] : r = [i[1], s] : t.toMillis() >= w.fromISO(i[0]).toMillis() ? r = [i[0], s] : r = [s, i[0]];
          break;
      }
      c("update:modelValue", r);
    }
    function v() {
      const { pickType: l, modelValue: t } = a;
      switch (l) {
        case h.single:
          return !!t;
        case h.range:
          return Array.isArray(t) && t.every((s) => !!s);
      }
    }
    const d = D(() => {
      switch (a.displayMode) {
        case T.scroll:
          return pe;
        case T.flat:
        default:
          return _e;
      }
    }), p = D(() => {
      const { pickType: l } = a;
      let t;
      switch (l) {
        case h.single:
          t = o.value;
          break;
        case h.range:
          t = o.value[0];
          break;
      }
      if (t)
        return y.value.findIndex(({ year: s, index: r }) => {
          const _ = t.set({ day: 1 }), n = w.fromFormat(`${s}-${r}`, "yyyy-M");
          return _.equals(n);
        });
    });
    return (l, t) => (f(), k("div", {
      class: O(["monster-calendar", [
        `monster-calendar--type--${a.pickType}`,
        { "monster-calendar--complete": v() }
      ]])
    }, [
      (f(), R(J(d.value), {
        class: "monster-calendar__display",
        "pick-type": e.pickType,
        "model-value": o.value,
        "week-day-names": u.value,
        months: y.value,
        "model-month-index": p.value,
        "months-to-show": e.displayMode === L(T).flat ? e.monthsToShow : void 0,
        onDayClick: M
      }, K({ _: 2 }, [
        e.displayMode === L(T).flat ? {
          name: "navigation",
          fn: Q(({ navigationState: s, changeMonthIndex: r }) => [
            q(l.$slots, "navigation", {
              navigationState: s,
              changeMonthIndex: r
            })
          ]),
          key: "0"
        } : void 0
      ]), 1064, ["pick-type", "model-value", "week-day-names", "months", "model-month-index", "months-to-show"]))
    ], 2));
  }
});
export {
  we as default
};
